<template>
    <div id="airwayPanel" class="airway-panel airway-mode-item"
        v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">
        <div v-if="airwaysData.total_volume" class="airway-item airway-total"
            v-bind:style="{ borderColor: mode.isWhite ? mode.blueColor : mode.whiteColor }"><span>Total volume: {{
            airwaysData.total_volume }}</span>
        </div>
        <div class="airway-list" ref="airwayList">
            <div v-for="slice in airwaysData.slices" class="airway-item" @click="sliceClick(slice)"
                v-bind:style="{ borderColor: mode.isWhite ? mode.blueColor : mode.whiteColor }">
                <span class="airway-header">{{ slice.name }}</span>
                <div class="airway-image-cont" v-bind:style="{
            border: slice.selected ? 'solid orange 3px' : 'solid transparent 3px',
        }">
                    <img class="airway-image-img" :src="slice.imageUrl" />
                    <img class="airway-image-enlarge-icon" src="images/enlarge_white.png" title="Enlarge Slice"
                        @click.prevent.stop="enlargeClick(slice)" />
                </div>
                <span v-if="slice.area" class="airway-label">Area: {{ slice.area }} mm<sup>2</sup></span>
                <span v-if="slice.ap_diameter" class="airway-label">AP distance: {{ slice.ap_diameter }} mm</span>
                <span v-if="slice.rl_diameter" class="airway-label">RL distance: {{ slice.rl_diameter }} mm</span>
                <span v-if="slice.position_text" class="airway-label">Slice position: {{ slice.position_text }}
                    mm</span>
            </div>

        </div>
    </div>
</template>

<script>

import {
    selectSlice,
    enlargeSlice
} from "./AirwayMode.js";


export default {
    name: "AirwayPanel",
    props: {
        airwaysData: {
            type: Object,
            required: true
        },
        mode: {
            type: Object,
            required: true
        },
    },
    mounted() {
        // console.log("AirwayPanel mounted");
    },
    methods: {
        sliceClick: function (slice) {
            selectSlice(slice);
        },
        enlargeClick: function (slice) {
            enlargeSlice(slice);
        },
    }
}

</script>

<style>
.airway-ellipse-btn {
    position: absolute;
    top: 73px;
    right: 10px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    z-index: 99;
}
</style>

<style scoped>
.airway-panel {
    position: absolute;
    top: 7px;
    right: 5px;
    height: calc(100% - 10px);
    width: 190px;
}

.airway-list {
    /* background-color: green; */
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
    height: calc(100% - 30px);
}

.airway-item {
    /* color: white; */
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 500;
    /* padding: 0.2rem; */
    border: solid white 0.1rem;

    margin-bottom: 3px;
    margin-right: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* gap: 1px; */
}

.airway-total {
    font-size: 15px;
    border: 0;
}

.airway-label {
    font-size: 13px;
    border: 0;
}

.airway-image-cont {
    width: 172px;
    height: 172px;
    position: relative;
    overflow: hidden;
}

.airway-image-img {
    width: 100%;
    /* height: 172px; */
    box-sizing: border-box;
    /* object-fit: cover; */
    /* border: solid orange 2px; */
}

.airway-image-enlarge-icon {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 20px;
    height: 20px;
    cursor: pointer;
}


::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
    background: #007bff;
}

::-webkit-scrollbar-thumb:hover {
    background: #007bff;
}
</style>